import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import RoleRoute from "@/components/RoleRoute";
import { AuthProvider } from "@/context/AuthContext";
import { BrandProvider } from "@/context/BrandContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import AdminPage from "@/pages/AdminPage";
import AuditPage from "@/pages/AuditPage";
import PlanPage from "@/pages/PlanPage";
import PublicPlanPage from "@/pages/PublicPlanPage";
import ClientsPage from "@/pages/ClientsPage";
import DashboardPage from "@/pages/DashboardPage";
import LoginPage from "@/pages/LoginPage";
import QuotePage from "@/pages/QuotePage";
import QuoteHistoryPage from "@/pages/QuoteHistoryPage";
import HistoricalSalesPage from "@/pages/HistoricalSalesPage";
import CobranzaPage from "@/pages/CobranzaPage";
import ReportsPage from "@/pages/ReportsPage";
import PlanVisitsPage from "@/pages/PlanVisitsPage";

export default function App() {
  return (
    <BrandProvider>
      <AuthProvider>
        <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
  path="/visor-plano"
  element={<PublicPlanPage />}
/>
              <Route element={<ProtectedRoute><CurrencyProvider><Layout /></CurrencyProvider></ProtectedRoute>}>
                <Route index element={<DashboardPage />} path="/" />
                <Route element={<QuotePage />} path="/cotizador" />
                <Route element={<QuoteHistoryPage />} path="/cotizaciones" />
                <Route
                  element={
                    <RoleRoute allowedRoles={["administrador", "supervisor"]}>
                      <HistoricalSalesPage />
                    </RoleRoute>
                  }
                  path="/ventas-historicas"
                />
                <Route element={<RoleRoute allowedRoles={["administrador", "supervisor"]}><CobranzaPage /></RoleRoute>} path="/cobranza" />
                <Route element={<ClientsPage />} path="/clientes" />
                <Route element={<ReportsPage />} path="/reportes" />
                <Route element={<RoleRoute allowedRoles={["administrador", "supervisor"]}><AuditPage /></RoleRoute>} path="/auditoria" />
                <Route element={<PlanPage />} path="/plano" />
                <Route
  element={
    <RoleRoute allowedRoles={["administrador", "supervisor"]}>
      <PlanVisitsPage />
    </RoleRoute>
  }
  path="/registro-visitas"
/>
                <Route element={<AdminPage />} path="/administracion" />
              </Route>
            </Routes>
          </BrowserRouter>
      </AuthProvider>
    </BrandProvider>
  );
}
